import { createStore } from 'vuex'
import { auth } from './auth-module'
import { helperModule } from './helper-module'

import { data } from './data-module'
import { sales } from './sales-module'
import { aktifitaspromo} from "@/store/aktifitaspromo-module";
import {materialModule} from "@/store/material-module"
import {salesReport} from "@/store/sales-report-module";
import { filter } from '@/store/filter-module'
import { customerModule} from "./customer-module";
import {vendorModule} from "./vendor-module";
import {warehouseModule} from "@/store/warehouse-module";
import {secretKey} from "@/store/secret-key";
import {potensi} from "@/store/potensi-module";

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    helperModule,
    data,
    sales,
    aktifitaspromo,
    materialModule,
    salesReport,
    filter,
    customerModule,
    vendorModule,
    warehouseModule,
      secretKey,
      potensi

  }
})
